import { render, staticRenderFns } from "./user-add.vue?vue&type=template&id=c4e62172"
import script from "./user-add.vue?vue&type=script&lang=js"
export * from "./user-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports